<template>
  <div class="om-design-wrapper">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'OMDesignWrapper',
  };
</script>
<style lang="scss">
  @import '~@om-design-system/web-components/dist/om-design-system-web/om-design-system-web.css';
  * {
    padding: revert-layer;
  }
</style>
